const { computePosition, shift, arrow, flip, offset, autoUpdate } = window.FloatingUIDOM;

const detectMob = () => {
    return window.innerWidth <= 750
}

const ARROW_SELECTOR = '.floating-arrow';
const ANNOUNCEMENT_BAR_LINK_CLASS = 'announcement-bar__side_link';

const offsetStrategy = (anchorElement) => {
    if (anchorElement.classList.contains(ANNOUNCEMENT_BAR_LINK_CLASS)) {
        return 6.5;
    }
    return 10;
}

const staticSideStrategy = (anchorElement) => {
    if (anchorElement.classList.contains(ANNOUNCEMENT_BAR_LINK_CLASS)) {
        return '-3px';
    }
    return '-4px';
}

function trackButton(buttonSelector, tooltipSelector, elementName, closeList, immediatelyShow = false) {
    if (detectMob()) return
    const button = document.querySelector(buttonSelector);
    const tooltip = document.querySelector(tooltipSelector);
    const arrowEl = tooltip.querySelector(ARROW_SELECTOR);

    if (!button || !tooltip) {
        console.log(`%c Tried to find element with selector ${buttonSelector} but couldn't find it.`, 'background: #222; color: red')
        console.log('button:', button)
        console.log(`%c Tried to find element with selector ${tooltipSelector} but couldn't find it.`, 'background: #222; color: red')
        console.log('tooltip:', tooltip)
        return
    }

    const offsetAmount = offsetStrategy(button);
    const updatePosition = () => {
        computePosition(button, tooltip, {
            placement: 'bottom',
            middleware: [
                flip(),
                shift(),
                offset(offsetAmount),
                arrow({ element: arrowEl }),
            ]
        }).then(({ x, y, placement, middlewareData }) => {
            Object.assign(tooltip.style, {
                left: `${x}px`,
                top: `${y}px`,
            });
            const { x: arrowX, y: arrowY } = middlewareData.arrow;
            const staticSide = {
                top: 'bottom',
                right: 'left',
                bottom: 'top',
                left: 'right',
            }[placement.split('-')[0]];

            if (!arrowEl) {
                console.log(`%c Tried to find element with selector ${ARROW_SELECTOR} but couldn't find it.`, 'background: #222; color: red')
                console.log('tooltip:', tooltip)
                return
            }

            Object.assign(arrowEl.style, {
                left: arrowX != null ? `${arrowX}px` : '',
                top: arrowY != null ? `${arrowY}px` : '',
                right: '',
                bottom: '',
                [staticSide]: staticSideStrategy(button),
            });
        });

        document.addEventListener(`modal-event-${elementName}-close`, (e) => {
            tooltip.style.display = 'none';
            tooltip.style.visibility = 'hidden';
        });

        document.addEventListener(`modal-event-${elementName}-open`, (e) => {
            tooltip.style.display = 'block';
            tooltip.style.visibility = 'visible';
        });
    };

    let updateCleanup;

    // Calculate position initially so that it can be displayed in the right position programatically from other events
    updateCleanup = autoUpdate(button, tooltip, updatePosition)

    // If immediatelyShow is true, show the tooltip immediately
    if (immediatelyShow) {
        tooltip.style.display = 'block'
        tooltip.style.visibility = 'visible'
    }

    button.addEventListener('mouseenter', (e) => {
        updateCleanup = autoUpdate(button, tooltip, updatePosition);
        requestAnimationFrame(() => {
            const toolTipIsDisabled = tooltip.classList.contains('disabled');
            if (!toolTipIsDisabled){
                let closeList = ['#support-tooltip', '#chat-unavailable-tooltip', '#chat-unavailable-tooltip', '#account-login-tooltip', 'cart-drawer'];
                let fCloseList = closeList.filter(m => m !== elementName);
                for (var i = fCloseList.length - 1; i >= 0; i--) {
                    document.querySelector(fCloseList[i]).style.display = 'none';
                    document.querySelector(fCloseList[i]).style.visibility = 'hidden';
                }
                tooltip.style.display = 'block';
                tooltip.style.visibility = 'visible';
            }
            document.addEventListener('mousemove', trackMouse);
        });
    });

    const trackMouse = (e) => {
        const buttonRect = button.getBoundingClientRect();
        const tooltipRect = tooltip.getBoundingClientRect();

        const isWithinExtendedRect = e.clientX > tooltipRect.left && e.clientX < tooltipRect.right && e.clientY > buttonRect.top && e.clientY < tooltipRect.bottom;

        if (!isWithinExtendedRect) {
            tooltip.style.display = 'none';
            tooltip.style.visibility = 'hidden';
            // tooltipe.style.filter = 'drop-shadow(1px 1px 4px rgba(0,0,0,.14))';
            document.removeEventListener('mousemove', trackMouse);
            if (updateCleanup) {
                updateCleanup();
                updateCleanup = null;
            }
        }
    };
}

function showDropdownMenu(supportDropdownIcon, supportTooltip) {
    trackButton(supportDropdownIcon, supportTooltip, supportTooltip, [], true)
}

function setFocusToSupportMenu(supportTooltip) {
    const wrap = document.querySelector(supportTooltip)
    if (!wrap) return
    const focusableElementsSelector = 'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
    const focusableElements = wrap.querySelectorAll(focusableElementsSelector)
    const visibleFocusableElements = Array.from(focusableElements).filter((el) => el.offsetWidth > 0 || el.offsetHeight > 0 || el.getClientRects().length > 0)
    if (visibleFocusableElements && visibleFocusableElements.length > 0) {
        visibleFocusableElements[0].focus()
    }
}

function listerToSupportOut(supportDropdownIcon) {
    const excludedSelector = '[data-header-support-icon], #support-tooltip'
    const supportTooltip = document.getElementById('support-tooltip')
    if (!supportTooltip) return

    supportDropdownIcon.addEventListener('keydown', (e) => {
        if (e.keyCode === 9 || e.code === 'Tab' || e.code === 'Escape') {
            supportTooltip.style.display = 'none'
            supportTooltip.style.visibility = 'hidden'
        }
    })
    document.addEventListener('click', function(event) {
        if (!event.target.closest(excludedSelector)) {
            console.log('Clicked outside dropdown');
            supportTooltip.style.display = 'none'
            supportTooltip.style.visibility = 'hidden'
        }
    })
    supportTooltip.addEventListener('keydown', function(event) {
        if (event.key === "Escape") {
            supportTooltip.style.display = 'none'
            supportTooltip.style.visibility = 'hidden'
            const dropIcon = document.querySelector('[data-header-support-icon]')
            dropIcon && dropIcon.focus()
        }
    })
    
}

document.addEventListener('DOMContentLoaded', () => {
    const supportDropdownIcon = document.querySelector('[data-header-support-icon]')
    if (!supportDropdownIcon) return
    supportDropdownIcon.addEventListener('mouseover', (e) => showDropdownMenu('[data-header-support-icon]', '#support-tooltip'))
    supportDropdownIcon.addEventListener('keydown', (e) => {
        if (['Enter'].includes(e.key) || e.code === 'Space') {
            showDropdownMenu('[data-header-support-icon]', '#support-tooltip')
            setFocusToSupportMenu('#support-tooltip')
            listerToSupportOut(supportDropdownIcon)
        }
    })
})

trackButton('[data-header-support-link]', '#support-tooltip');
trackButton('[data-header-support-icon]', '#support-tooltip');
trackButton('.header__chat_live', '#chat-unavailable-tooltip');
trackButton('.header-onscroll__chat_live_link', '#chat-unavailable-tooltip');
trackButton('.header__icons .header__icon', '#account-login-tooltip');

trackButton('#cart-icon-bubble', 'cart-drawer', 'cart-drawer');
